import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const CategoryHero = ({ category }) => {
  const { language } = useLanguage();
  
  const categoryHeroes = {
    televisores: {
      title: { es: 'Televisores', en: 'TVs' },
      subtitle: { es: 'Entretenimiento sin límites', en: 'Unlimited Entertainment' },
      image: 'https://images.unsplash.com/photo-1761330439671-a7f20c285c5e',
      gradient: 'from-blue-500/20 to-purple-500/20'
    },
    aires: {
      title: { es: 'Aires Acondicionados', en: 'Air Conditioners' },
      subtitle: { es: 'Confort perfecto todo el año', en: 'Perfect Comfort All Year' },
      image: 'https://images.unsplash.com/photo-1718894071085-5be03ad32a53',
      gradient: 'from-cyan-500/20 to-blue-500/20'
    },
    electrodomesticos: {
      title: { es: 'Electrodomésticos', en: 'Appliances' },
      subtitle: { es: 'Simplifica tu día a día', en: 'Simplify Your Daily Life' },
      image: 'https://images.unsplash.com/photo-1769326541231-c6bd945b75f9',
      gradient: 'from-green-500/20 to-teal-500/20'
    },
    abanicos: {
      title: { es: 'Abanicos', en: 'Fans' },
      subtitle: { es: 'Frescura donde la necesites', en: 'Freshness Where You Need It' },
      image: 'https://images.unsplash.com/photo-1612549672719-2f1a3908ae31',
      gradient: 'from-gray-500/20 to-slate-500/20'
    },
    audio: {
      title: { es: 'Audio', en: 'Audio' },
      subtitle: { es: 'Sonido que te envuelve', en: 'Immersive Sound' },
      image: 'https://images.unsplash.com/photo-1691290692144-c456d4c2751c',
      gradient: 'from-orange-500/20 to-red-500/20'
    }
  };

  const hero = categoryHeroes[category];
  
  if (!hero || category === 'todos') return null;

  return (
    <div className="relative h-64 mb-12 rounded-2xl overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-700">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center transform scale-105 transition-transform duration-700"
        style={{ backgroundImage: `url(${hero.image})` }}
      />
      
      {/* Overlay Gradient */}
      <div className={`absolute inset-0 bg-gradient-to-r ${hero.gradient} backdrop-blur-sm`} />
      
      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-center px-4">
        <h2 className="text-4xl md:text-5xl font-bold mb-3 text-white drop-shadow-lg">
          {hero.title[language]}
        </h2>
        <p className="text-xl md:text-2xl text-white/90 drop-shadow-md">
          {hero.subtitle[language]}
        </p>
      </div>
    </div>
  );
};

export default CategoryHero;
